import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { DtoHasApi } from 'src/core/models/shared/dto-has-api.model';
import { FeedbackDto } from 'src/core/models/feedback/feedback.dto';
import { AgentSummaryDto } from 'src/core/models/feedback/agent-summary.dto';

@Injectable({
  providedIn: 'root',
})
export class FeedbackService {
  constructor(private http: HttpClient) {}

  create(feedback: FeedbackDto): Observable<FeedbackDto> {
    const url = this.getApiUrl(FeedbackDto) + '/create';
    return this.http.post(url, feedback) as Observable<FeedbackDto>;
  }
  getAgentSummary(agentId: string, dateFrom: Date, dateTo: Date): Observable<AgentSummaryDto> {
    let params = new HttpParams()
      .set('agentId', agentId)
      .set('dateFrom', dateFrom.toISOString())
      .set('dateTo', dateTo.toISOString());

    return this.http.get<AgentSummaryDto>(this.getApiUrl(FeedbackDto) + '/agent-summary', {
      params,
    });
  }
  getByIdAndMarkAsRead(id: number): Observable<FeedbackDto> {
    const url = this.getApiUrl(FeedbackDto) + `/${id}`;
    return this.http.get<FeedbackDto>(url);
  }

  protected getApiUrl(type = DtoHasApi): string {
    const apiBase = environment.apis.default.url;
    return apiBase + '/' + type.apiUrl;
  }
}
